<template>
<div>
  <b-modal id="modallg" size="lg" @hidden="resetData" ok-only>

    <h2 class="m-t-0 m-b-30">Order no: <b-badge variant="success" class="badge-custom">{{orderRecord.order_no}}</b-badge>
    </h2>
    <h4 class="m-b-30"></h4>
    <b-row>
      <b-col cols="8">
        <section>
          <div class="order-detail">
            <b-table-simple hover caption-top responsive striped>
              <b-thead head-variant="dark">
                <b-tr>
                  <b-th colspan="2">Order Data</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-th class="text-right">Order Id :</b-th>
                  <b-th>{{ orderRecord.order_no }}</b-th>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Customer Name :</b-th>
                  <b-th>{{orderRecord.customerFirstName }} {{orderRecord.customerLastName }}</b-th>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Customer Email :</b-th>
                  <b-th>{{ orderRecord.customerEmail }}</b-th>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Created at :</b-th>
                  <b-th>{{ moment(orderRecord.created_in_shopify).utcOffset("+00:00").format('DD-MM-YYYY, h:mm:ss a') }}</b-th>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">Updated at :</b-th>
                  <b-th>{{ moment(orderRecord.updated_at_shopify).utcOffset("+00:00").format('DD-MM-YYYY, h:mm:ss a')   }}</b-th>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </section>
      </b-col>
    </b-row>
    <div class="order-items m-t-20 m-b-20">
      <b-table striped hover :items="orderRecord.ShopifyOrderItems" :fields="fields" head-variant="dark">
      </b-table>
    </div>

    <!-- ////////////// Customer Order Files /////////////// -->
    <section class="order-files">
      <section class="order-properties">

        <div v-for="item in orderRecord.ShopifyOrderItems" v-bind:key="item.id" class="m-b-20">
          <h4 class="m-b-20">Order Item Name: {{item.name}}</h4>

          <b-card-group deck >
            
            <!-- <b-card v-if="property.name && property.name.toLowerCase().includes('uploadery')" :title="property.name" :img-src="`${getBase(property.value)}preview_${property.value.split('/').pop()}`" img-alt="Image" img-top tag="article" style="max-width: 20rem;" class="mb-2">

              <b-button block variant="primary" class="m-b-20" :disabled="downloadInProgress"  @click.prevent="downloadFileFromServer(item.name, orderRecord.order_no,  property.value)">
                <b-spinner small v-if="downloadInProgress"></b-spinner>
                Download Renamed File</b-button>

              <a :href="property.value" class="btn btn-default btn-block">Download not renamed</a>

            </b-card> -->
            <b-card v-for="(property, index) in item.properties" v-bind:key="index"  border-variant="primary" :header="property.name" header-bg-variant="primary" header-text-variant="white" align="center" style="max-width: 20rem;">
              <b-card-text>{{ property.value ? property.value : "Customer didn't enter any value" }}</b-card-text>
            </b-card>
          </b-card-group>

        </div>

      </section>
      <div>
        <b-button variant="outline-primary" class="m-b-10" @click="fetchCustomerOrderHistory()">Show Customer Order History</b-button>
        <section>
          <div class="text-center" v-if="processing">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <div role="tablist" v-else>

            <b-card no-body class="mb-1" v-for="order in customerOrderHistory" v-bind:key="order.id">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle="'accordion-' + order.id" variant="primary" size="lg">
                   
                   
                  <h4 class="tab-header-title">
                    <div v-if="orderRecord.order_no == order.order_no" >
                      <b-icon icon="arrow-right" animation="cylon" font-scale="2"></b-icon>
                    </div>
                    Order No: {{order.order_no}}
                  </h4>
                </b-button>
              </b-card-header>
              <b-collapse :id="'accordion-' + order.id" accordion="my-accordion" role="tabpanel">
                <b-card-body>

                  <div v-for="item in order.ShopifyOrderItems" v-bind:key="item.id">
                    <h4>{{ item.name}}</h4>

                    <b-card-group deck v-for="(property, index) in item.properties" v-bind:key="index">
                      <b-card v-if="property.name && property.name.toLowerCase().includes('uploadery')" :title="property.name" :img-src="`${getBase(property.value)}preview_${property.value.split('/').pop()}`" img-alt="Image" img-top tag="article" style="max-width: 20rem;" class="mb-2">

                        <b-button block variant="primary" :disabled="downloadInProgress" @click.prevent="downloadFileFromServer(item.name, order.order_no,  property.value)" >
                          
                          <b-spinner small v-if="downloadInProgress"></b-spinner>
                          

                          Download Renamed File
                          
                          </b-button>

                        <a :href="property.value" class="btn btn-default btn-block" download>Download not renamed file</a>

                      </b-card>
                      <b-card v-else border-variant="primary" :header="property.name" header-bg-variant="primary" header-text-variant="white" align="center" style="max-width: 20rem;">
                        <b-card-text>{{ property.value ? property.value : "Customer didn't enter any value" }}</b-card-text>
                      </b-card>
                    </b-card-group>

                  </div>

                </b-card-body>
              </b-collapse>
            </b-card>

          </div>

        </section>
      </div>
    </section>
    <b-row>
      <b-col>
        <b-table-simple hover caption-top responsive striped>
          <b-thead head-variant="dark">
            <b-tr>
              <b-th colspan="2">Shipping Details</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-th>First name</b-th>
              <b-td>{{ orderRecord.ShopifyShippingAddress ? orderRecord.ShopifyShippingAddress.firstName : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Last name</b-th>
              <b-td>{{ orderRecord.ShopifyShippingAddress ? orderRecord.ShopifyShippingAddress.lastName : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Phone</b-th>
              <b-td>{{ orderRecord.ShopifyShippingAddress ? orderRecord.ShopifyShippingAddress.phone : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>City</b-th>
              <b-td>{{ orderRecord.ShopifyShippingAddress ? orderRecord.ShopifyShippingAddress.city : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Zip</b-th>
              <b-td>{{ orderRecord.ShopifyShippingAddress ? orderRecord.ShopifyShippingAddress.zip : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Province</b-th>
              <b-td>{{ orderRecord.ShopifyShippingAddress ? orderRecord.ShopifyShippingAddress.province : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Country</b-th>
              <b-td>{{ orderRecord.ShopifyShippingAddress ? orderRecord.ShopifyShippingAddress.country : "" }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
      <b-col>
        <b-table-simple hover caption-top responsive striped>
          <b-thead head-variant="dark">
            <b-tr>
              <b-th colspan="2">Billing Details</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-th>First name</b-th>
              <b-td>{{ orderRecord.ShopifyBillingAddress ? orderRecord.ShopifyBillingAddress.firstName : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Last name</b-th>
              <b-td>{{ orderRecord.ShopifyBillingAddress ? orderRecord.ShopifyBillingAddress.lastName : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Phone</b-th>
              <b-td>{{ orderRecord.ShopifyBillingAddress ? orderRecord.ShopifyBillingAddress.phone : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>City</b-th>
              <b-td>{{ orderRecord.ShopifyBillingAddress ? orderRecord.ShopifyBillingAddress.city : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Zip</b-th>
              <b-td>{{ orderRecord.ShopifyBillingAddress ? orderRecord.ShopifyBillingAddress.zip : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Province</b-th>
              <b-td>{{ orderRecord.ShopifyBillingAddress ? orderRecord.ShopifyBillingAddress.province : "" }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Country</b-th>
              <b-td>{{ orderRecord.ShopifyBillingAddress ? orderRecord.ShopifyBillingAddress.country : "" }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>

  </b-modal>
</div>
</template>

<script>
import EventBus from '../../EventBus';
import OrdersService from '../../services/orders.service';
import DownloadFileMixin from './mixins/download-file.mixin'
import {
  API_URL
} from "../../services/constants";
export default {
  data() {
    return {
      orderRecord: {},
      fields: [{
          key: 'variant_title',
          label: 'Order Item Variant Title'
        },
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'shopify_product_variant_id',
          label: 'Variant Id'
        },
        {
          key: 'price',
        },
        {
          key: 'quantity'
        },
        {
          key: 'sku'
        },
      ],
      items: [],
      order_no: '',
      headerBgVariant: 'dark',
      headerTextVariant: 'light',
      customerOrderHistory: [],
      processing: false,
      downloadInProgress: false
    }
  },
  mixins:[DownloadFileMixin],
  methods: {
    
    getDimensionInfo(property, index1, index2) {
      console.log('Calculating widht and height of image')
      let img = new Image();

      img.onload = () => {
        this.items[index1].properties[index2].width = img.width;
        this.items[index1].properties[index2].height = img.height;
      }

      img.src = property.value;

    },
    async fetchCustomerOrderHistory() {

      this.processing = true;
      const orderId = this.items[0].shopify_order_id;

      const result = await OrdersService.fetchCustomerOrdersHistory(orderId);

      this.customerOrderHistory = result.data.history;
      this.processing = false;

    },
    resetData() {
      this.customerOrderHistory = []
      this.orderRecord = {}
    },

  },
  mounted() {
    EventBus.$on('show-orders-details', (order) => {
      this.orderRecord = order;
      this.items = order.ShopifyOrderItems;

      this.items.forEach((item, index1) => {
        item.properties.forEach((property, index2) => {
          if (property.name.includes('uploadery')) {
            this.$set(this.items[index1].properties[index2], 'width', '...');
            this.$set(this.items[index1].properties[index2], 'height', '...');
            this.getDimensionInfo(property, index1, index2);
          }
        })
      })
    });

  },
  beforeDestroy() {
    EventBus.$off('show-orders-details');
  }
}
</script>

<style lang="scss" scoped>
.modal-title {
  font-size: 30px;
}

.badge-custom {
  font-size: inherit;
}

ul {
  list-style-type: none;
  padding-left: 0;

  li {
    width: 200px;
    display: inline-block;
  }
}
.tab-header-title{
  position: relative;
  div{
    position: absolute;
    left: 0;
    top: -3px;

  }
}
</style>
